import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

import { deliverablesQuerySchema } from '../deliverables';

export const subsidyItemsQuerySchema = z.object({
  id: z.number(),
  subsidy_id: z.number(),
  agreement_deliverable_id: z.number(),
  agreement_deliverable: deliverablesQuerySchema
    .pick({
      id: true,
      product_name: true,
      product_id: true,
      sku: true,
      price: true,
      quantity: true,
    })
    .nullable(),
  amount: currencyInput.querySchema(),
  percentage: currencyInput.querySchema(),
  start_date: z.string().nullable(),
  end_date: z.string().nullable(),
  quantity: currencyInput.querySchema(),
});

export type SubsidyItemsQuerySchema = z.infer<typeof subsidyItemsQuerySchema>;

export const subsidyItemsFormSchema = subsidyItemsQuerySchema
  .extend({
    amount: currencyInput.formSchema(),
    percentage: currencyInput.formSchema(),
    quantity: currencyInput.formSchema(),
  })
  .refine(
    ({ start_date }) => {
      return !!start_date;
    },
    {
      message: 'Start Date is required',
      path: ['start_date'],
    }
  )
  .refine(
    ({ end_date }) => {
      return !!end_date;
    },
    {
      message: 'End Date is required',
      path: ['end_date'],
    }
  );

export type SubsidyItemsFormSchema = z.infer<typeof subsidyItemsFormSchema>;

export const subsidyItemsMutationSchema = subsidyItemsQuerySchema
  .omit({
    agreement_deliverable: true,
  })
  .extend({
    amount: currencyInput.mutationSchema(),
    percentage: currencyInput.mutationSchema(),
  });

export type SubsidyItemsMutationSchema = z.infer<typeof subsidyItemsMutationSchema>;

export const subsidyItemsCreateSchema = subsidyItemsMutationSchema.omit({
  id: true,
});

export type SubsidyItemsCreateSchema = z.infer<typeof subsidyItemsCreateSchema>;
